function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-len */
import { CloseButton as ChakraCloseButton } from '@chakra-ui/close-button';
import { Icon } from '@chakra-ui/icon';
import { forwardRef } from '@chakra-ui/system';
import * as React from 'react';

var CloseIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  "aria-hidden": true,
  focusable: "false",
  height: "100%",
  width: "100%"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 6.5C10.7958 10.7958 17.5 17.5 17.5 17.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 6.5C13.2042 10.7958 6.5 17.5 6.5 17.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2"
}));

var CloseIconThin = props => /*#__PURE__*/React.createElement(Icon, _extends({
  "aria-hidden": true,
  focusable: "false",
  height: "100%",
  width: "100%"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1 23L23 1M1 1L23 23",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "2"
}));

export var CloseButton = forwardRef((props, ref) => {
  var Icon = props.variant === 'thin' ? CloseIconThin : CloseIcon;
  return /*#__PURE__*/React.createElement(ChakraCloseButton, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Icon, null));
});
//# sourceMappingURL=close-button.js.map